/** @hidden */
export var internalZoomFactorChange = 'internalZoomFactorChange';
/** @hidden */
export var contentChangeEvent = 'contentChange';
/** @hidden */
export var documentChangeEvent = 'documentChange';
/** @hidden */
export var selectionChangeEvent = 'selectionChange';
/** @hidden */
export var zoomFactorChangeEvent = 'zoomFactorChange';
/** @hidden */
export var beforeFieldFillEvent = 'beforeFieldFill';
/** @hidden */
export var afterFieldFillEvent = 'afterFieldFill';
/** @hidden */
export var afterFormFieldFillEvent = 'afterFormFieldFill';
/** @hidden */
export var beforeFormFieldFillEvent = 'beforeFormFieldFill';
/** @hidden */
export var serviceFailureEvent = 'serviceFailure';
/** @hidden */
export var viewChangeEvent = 'viewChange';
/** @hidden */
export var customContextMenuSelectEvent = 'customContextMenuSelect';
/** @hidden */
export var customContextMenuBeforeOpenEvent = 'customContextMenuBeforeOpen';
/** @hidden */
export var contentControlEvent = 'contentControl';
/** @hidden */
export var beforecontentControlFillEvent = 'beforeContentControlFill';
/** @hidden */
export var aftercontentControlFillEvent = 'afterContentControlFill';
/** @hidden */
export var commentBeginEvent = 'commentBegin';
/** @hidden */
export var commentEndEvent = 'commentEnd';
/** @hidden */
export var beforeCommentActionEvent = 'beforeCommentAction';
/** @hidden */
export var commentDeleteEvent = 'commentDelete';
/** @hidden */
export var revisionActionEvent = 'beforeAcceptRejectChanges';
/** @hidden */
export var beforePaneSwitchEvent = 'beforePaneSwitch';
/** @hidden */
export var requestNavigateEvent = 'requestNavigate';
/** @hidden */
export var actionCompleteEvent = 'actionComplete';
/** @hidden */
export var trackChangeEvent = 'trackChange';
/** @hidden */
export var searchResultsChangeEvent = 'searchResultsChange';
/** @hidden */
export var keyDownEvent = 'keyDown';
/** @hidden */
export var toolbarClickEvent = 'toolbarClick';
/** @hidden */
export var beforeFileOpenEvent = 'beforeFileOpen';
/** @hidden */
export var internalviewChangeEvent = 'internalviewChange';
/** @hidden */
export var beforeXmlHttpRequestSend = 'beforeXmlHttpRequestSend';
/** @hidden */
export var protectionTypeChangeEvent = 'protectionTypeChange';
/** @hidden */
export var internalDocumentEditorSettingsChange = 'internalDocumentEditorSettingsChange';
/** @hidden */
export var internalStyleCollectionChange = 'internalStyleCollectionChange';
/** @hidden */
export var internalAsyncPagesVisible = 'internalAsyncPagesVisible';
/** @hidden */
export var defaultFont = 'Times New Roman';
/** @hidden */
export var internalAutoResize = 'internalAutoResize';
/** @hidden */
export var beforeAutoResize = 'beforeAutoResize';
/** @hidden */
export var trackChanges = 'trackChanges';
/** @hidden */
export var internalOptionPaneChange = 'internalOptionPaneChange';
/** @hidden */
export var documentLoadFailedEvent = 'documentLoadFailed';
/**
 * File menu item click event
 * @hidden
 */
export var fileMenuItemClickEvent = 'fileMenuItemClick';
/**
 * Triggered before paste operation is executed
 *
 * @hidden
 */
export var beforePaste = 'beforePaste';
/**
 * Triggers when pages loads asynchronously in the document editor
 * @hidden
 */
export var asyncPagesVisible = 'asyncPagesVisible';
/**
 * Triggered when the border style other than solid type is clicked
 *
 * @hidden
 */
export var unsupportedBorderStyleClick = 'unsupportedBorderStyleClick';
